export { default } from './CircumventionWarning';
export * from './CircumventionWarning';
export { default as circumventionKeywordMatches } from './circumventionKeywordMatches';



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/messages/components/CircumventionWarning/index.ts